<div class="mt-4">
  <!-- Header Area -->
  <div class="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4 mb-6">
    <div class="flex-1 max-w-md">
      <p-iconField iconPosition="left">
        <p-inputIcon styleClass="pi pi-search text-slate-400" />
        <input type="text" pInputText placeholder="{{ 'insurance_procedures_search_placeholder' | translate }}"
          class="w-full !bg-white !border-slate-200 !rounded-xl !text-sm focus:!ring-2 focus:!ring-primary/10 focus:!border-primary !shadow-sm transition-all"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearch($event)"
          (keyup.enter)="onSearch(searchText)">
      </p-iconField>
    </div>

    <app-button *hasPermission="'Procedimentos:create'" label="{{ 'insurance_procedures_add_button' | translate }}" icon="pi pi-plus" variant="primary"
      (onClick)="showAddModal = true">
    </app-button>
  </div>

  <!-- Prime Table -->
  <app-prime-table [columns]="columns" [data]="healthPlans" [loading]="loading" [totalRecords]="totalRecords"
    [rows]="rows" [first]="first" [paginator]="true" [lazy]="true" [templates]="templates"
    (onLazyLoad)="onPageChange($event)">
  </app-prime-table>

  <!-- Templates -->
  <ng-template #statusTemplate let-item>
    <span class="px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest shadow-sm" [ngClass]="{
        'status-success': item.active === true,
        'bg-slate-100 text-slate-400 border border-slate-200': item.active !== true
      }">
      {{ (item.active === true ? 'status_active' : 'status_inactive') | translate }}
    </span>
  </ng-template>

  <ng-template #actionsTemplate let-item>
    <div class="flex items-center justify-center gap-1">
      <button (click)="viewProcedures(item)" title="{{ 'health_plan_procedures_view_button' | translate }}"
        class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
        <i class="pi pi-list"></i>
      </button>
      <app-dropdown *hasPermission="'Procedimentos:edit'">
      <ng-template #trigger>
        <button class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
          </svg>
        </button>
      </ng-template>
      <ng-template #content>
        <div class="w-48 py-1">
          <button (click)="editHealthPlan(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <svg class="h-4 w-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
            {{ 'action_edit' | translate }}
          </button>

          <button (click)="toggleStatus(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <svg class="h-4 w-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1v3M4 7h16" />
            </svg>
            {{ (item.active ? 'action_deactivate' : 'action_activate') | translate }}
          </button>
        </div>
      </ng-template>
      </app-dropdown>
    </div>
  </ng-template>

  <!-- Modals -->
  <app-add-health-plan-modal *ngIf="showAddModal" [isOpen]="showAddModal" [branchId]="branchId"
    [healthPlan]="selectedHealthPlan" (close)="onModalClose()" (planAdded)="onAddHealthPlanSuccess()"
    (planSaved)="onAddHealthPlanSuccess()">
  </app-add-health-plan-modal>

  <app-health-plan-procedures-modal [isOpen]="showProceduresModal"
    [healthPlanId]="selectedHealthPlanForProcedures?.id ?? null"
    [healthPlanName]="selectedHealthPlanForProcedures?.name ?? ''" [branchId]="branchId"
    (close)="closeProceduresModal()">
  </app-health-plan-procedures-modal>
</div>